import { render } from "./FacultyCourseOutcomesDialog.vue?vue&type=template&id=6ecb3ee0"
import script from "./FacultyCourseOutcomesDialog.vue?vue&type=script&lang=js"
export * from "./FacultyCourseOutcomesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__